// extracted by mini-css-extract-plugin
module.exports = {"heading":"contentHeading_heading__3r38p","hide":"contentHeading_hide__qhhdV"};